/* Count-up pro [data-countup]: najde prvni cislo >= 1000 v textu, obali ho
   nezalomitelnym spanem se zamcenou sirkou a napocita po cislicich:
   KAZDA cislice zvlast jede od 0 primo na svou cilovou hodnotu
   (3 jede 0->3, 7 jede 0->7), plynule s easeOut. Cislice vpravo
   dojizdeji o kousek dele. Oddelovace mezer zustavaji.
   Mala cisla (roky, "z 5") nechava byt. Guard window.__yerbCountup,
   IntersectionObserver, respektuje prefers-reduced-motion. */
(function () {
  if (window.__yerbCountup) return;
  window.__yerbCountup = true;

  var els = document.querySelectorAll('[data-countup]');
  if (!els.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var TOKEN = /\d{1,3}(?:[   ]\d{3})+|\d{4,}/;

  function fmt(n) {
    var s = String(n);
    var out = '';
    while (s.length > 3) { out = ' ' + s.slice(-3) + out; s = s.slice(0, -3); }
    return s + out;
  }

  function prepare(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var m = node.nodeValue.match(TOKEN);
      if (!m) continue;
      var target = parseInt(m[0].replace(/\D/g, ''), 10);
      if (!(target >= 1000)) continue;
      var span = document.createElement('span');
      span.style.whiteSpace = 'nowrap';
      span.style.fontVariantNumeric = 'tabular-nums';
      span.textContent = fmt(target);
      var after = node.splitText(m.index);
      after.nodeValue = after.nodeValue.slice(m[0].length);
      node.parentNode.insertBefore(span, after);
      return { span: span, final: fmt(target) };
    }
    return null;
  }

  var BASE = 1800;      /* doba nabehu prvni cislice */
  var EXTRA = 150;      /* kazda dalsi cislice dojizdi o tolik dele */

  function run(job) {
    if (reduced) return;
    var s = job.span;
    /* Zamknout sirku na finalni hodnotu - okoli se behem animace nehne. */
    var w = s.offsetWidth;
    if (w) {
      s.style.display = 'inline-block';
      s.style.minWidth = w + 'px';
      s.style.textAlign = 'right';
    }
    var chars = job.final.split('');
    var t0 = null;
    function frame(ts) {
      if (!t0) t0 = ts;
      var elapsed = ts - t0;
      var out = '';
      var di = 0;
      var running = false;
      for (var i = 0; i < chars.length; i++) {
        var ch = chars[i];
        if (ch < '0' || ch > '9') { out += ch; continue; }
        var dur = BASE + di * EXTRA;
        var p = Math.min(elapsed / dur, 1);
        if (p < 1) running = true;
        var e = 1 - Math.pow(1 - p, 3);
        var targetD = ch.charCodeAt(0) - 48;
        out += String(Math.round(e * targetD));
        di++;
      }
      s.textContent = out;
      if (running) requestAnimationFrame(frame);
      else s.textContent = job.final;
    }
    requestAnimationFrame(frame);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      io.unobserve(en.target);
      var job = en.target.__yerbCntJob;
      if (job) run(job);
    });
  }, { threshold: 0.4 });

  els.forEach(function (el) {
    var job = prepare(el);
    if (!job) return;
    el.__yerbCntJob = job;
    io.observe(el);
  });
})();
